import React from 'react'
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
const ToolTip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }}></Tooltip>
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      color: "#fff",
      backgroundColor: "#75428C",
      boxShadow: theme.shadows[1],
      fontSize: 13,
    },
  }));
function ToolTipComponent({title,placement,tooltipContent}) {
  return (
    <ToolTip
    title={title}
    placement={placement}
    followCursor
  >
    <span>{tooltipContent}</span>
  </ToolTip>
  )
}

export default ToolTipComponent